import React from 'react'
import { unique } from "@helpers";
import { Column } from "react-table";

export default [
    {
        Header: 'Number',
        accessor: 'number',
        width: '50%'
    },
    {
        Header: 'Comment',
        accessor: 'comment',
        width: '50%'
    },
    {
        Header: 'Recipients',
        accessor: row => row.participations.map(item => item.user.id).filter(unique).length,
        Cell: ({ value }: any) => <>{value} customers</>
    },
    {
        Header: 'Contents',
        accessor: row => row.participations.length,
        Cell: ({ value }: any) => <>{value} awards</>
    }
] as Column<Admin.Resources.Tracking>[]